"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = _interopRequireDefault(require("@soltalabs/constants"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CONSTANTS = {
  PROFILE: {
    ACTIONS: {
      ACTIVATION: 'activation',
      RESET: 'reset'
    }
  },
  ROLES: {
    PLATFORM_ADMIN: 'platform_admin',
    ORG_ADMIN: 'organization_roles_admin',
    ORG_CONTRACT_MANAGER: 'organization_roles_manager',
    ORG_MANAGER: 'organization_roles_manager',
    ORG_FOREMAN: 'organization_roles_foreman'
  },
  NOTIFICATION_EMAIL_TYPES: {
    ACCOUNT_ACTIVATION: 'activation',
    ACCOUNT_RESET_PASSWORD: 'reset_password',
    JOB_IMPORT_COMPLETED: 'job_import_completed',
    SUPPORT_REQUEST: 'support_request',
    INVITATION: 'invitation'
  },
  NOTIFICATION_STATUSES: {
    PROCESSED: 'notification_processed',
    SENT: 'notification_sent',
    FAILED: 'notification_failed'
  },
  SUPPORT_TICKET_SOURCES: {
    WEB: 'support_ticket_web',
    APP: 'support_ticket_app'
  },
  SUPPORT_TICKET_STATUSES: {
    SUBMITTED: 'support_ticket_submitted',
    PROCESSED: 'support_ticket_processed',
    RESPONDED: 'support_ticket_responsed'
  },
  APPLICATION_RATE: {
    ONE: '1L',
    TWO: '2L',
    THREE: '3L'
  },
  APPLICABLE_ALGORITHM: {
    RS1_2HRS: 'RS1:2hrs',
    RS1_4HRS: 'RS1:4hrs',
    RS1_6HRS: 'RS1:6hrs',
    POLY_3HRS: 'Poly:3hrs',
    POLY_6HRS: 'Poly:6hrs',
    POLY_10HRS: 'Poly:10hrs',
    RAVENSDOWN: 'RAVENSDOWN'
  },
  NUMBER_OF_ASSESSMENTS: {
    HOURS: 72
  },
  ALGORITHMS: {
    RS1: 'RS1',
    POLY: 'Poly'
  },
  TILER_DATA_EVENTS: {
    READY: 'tiler_data_ready'
  },
  JOB_EVENTS: {
    CREATED: 'job_created',
    UPDATED: 'job_updated',
    ASSESSMENTS_REQUESTED: 'job_assessments_requested'
  },
  JOB_IMPORT_EVENTS: {
    READY: 'job_import_ready',
    STARTED: 'job_import_started',
    COMPLETED: 'job_import_completed'
  },
  JOB_IMPORT_STATUS: {
    COMPLETED: 'completed',
    FAILED: 'failed',
    PROCESSING: 'processing',
    NOT_YET_PROCESSED: 'not_yet_processed'
  },
  JOB_LIST_TYPES: {
    ALL_JOBS: 'all_jobs',
    SCHEDULED_JOBS: 'scheduled_jobs',
    UNASSIGNED_JOBS: 'unassigned_jobs'
  },
  MAX_NUMBER_OF_TILES: {
    TILES: 81
  },
  FORECAST_POLYGON_TYPE: {
    TEMPARATURE: 'temparature',
    PRECIPITATION: 'precipitation',
    COMBINED: 'combined',
    ACCUMULATED: 'accumulated'
  },
  JOB_SOURCE: {
    APP: 'job_source_app',
    BULK_UPLOAD: 'job_source_bulk_upload'
  },
  RS1_APPLICATION_RATE_VALUE: {
    '1L': 4.3,
    '2L': 7.7,
    '3L': 9
  },
  POLY_APPLICATION_RATE_VALUE: {
    '1L': 500,
    '2L': 1000,
    '3L': 1500
  },
  INVITATION_STATUSES: {
    PENDING: 'inv_status_pending',
    ACCEPTED: 'inv_status_accepted'
  }
};

var _default = _objectSpread({}, _constants.default, {}, CONSTANTS);

exports.default = _default;